<div *ngIf="(show$ | async) === true">
  <div class="backdrop"></div>
  <div class="waiting-toast-container">
    <div class="title">Attendere</div>
    <ion-progress-bar [value]="progressionValue$ | async"></ion-progress-bar>
    <div class="message">{{ message$ | async }}</div>
  </div>
</div>